module.exports = "<svg width=\"22px\" height=\"22px\" viewBox=\"0 0 22 22\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8.17142857,5.97142857 L15.8714286,13.6714286 C16.1857143,13.9857143 16.1857143,14.4571429 15.8714286,14.7714286 L14.7714286,15.8714286 C14.4571429,16.1857143 13.9857143,16.1857143 13.6714286,15.8714286 L5.97142857,8.17142857 C5.65714286,7.85714286 5.65714286,7.38571429 5.97142857,7.07142857 L7.07142857,5.97142857 C7.38571429,5.65714286 7.85714286,5.65714286 8.17142857,5.97142857\" id=\"Shape\"></path></svg>\n"


//////////////////
// WEBPACK FOOTER
// /home/git/gitlab/app/views/shared/icons/_icon_status_canceled_borderless.svg
// module id = 8r0p
// module chunks = 5 6 7 8